import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';

import styles from '../../PackagesRoomsAmenities.module.scss';

import type { EntitySectionConfig } from './entity';

type RenderSection<T> = (section: EntitySectionConfig<T>) => React.ReactNode;

type Props<T> = {
  title?: string;
  createLabel?: string;
  sections: EntitySectionConfig<T>[];
  renderSection: RenderSection<T>;
  onCreate?: () => void;
  extra?: React.ReactNode;
  containerRef?: React.Ref<HTMLDivElement>;
  bordered?: boolean;
};

export const EntityTable = <T,>({
  title,
  createLabel,
  sections,
  renderSection,
  onCreate,
  extra,
  containerRef,
  bordered = true,
}: Props<T>) => (
  <div
    ref={containerRef}
    className={classNames(styles.card, { [styles.flat]: !bordered })}
  >
    {title && (
      <div className={styles.headerRow}>
        <div className={styles.headerTitle}>{title}</div>
        <div className={styles.headerActions}>
          {extra}
          {onCreate && (
            <Button icon={<PlusOutlined />} onClick={onCreate}>
              {createLabel}
            </Button>
          )}
        </div>
      </div>
    )}

    {sections.map(renderSection)}
  </div>
);
